import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import HeadSection from "./HeadSection";
import AboutSection from "./AboutSection";
import AboutSection2 from "./AboutSection2";
import NewsSection from "./NewsSection";
import SpecialOffersSection from "./SpecialOffersSection";
import APISection from "./APISection";
import RegisterSection from "./RegisterSection";
import ContactUsSection from "./ContactUsSection";
import MapSection from "./MapSection";
import Footer from "./../footer/Footer";
import styled, { createGlobalStyle } from 'styled-components';
import api from './../../../shared/functions/api';
import { toTitleCase } from './../../../shared/functions/strings';
import {
  withWidth,
} from "@material-ui/core";
import ConditionalWrapper from 'shared/components/ConditionalWrapper';

const HideTrengoChat = createGlobalStyle`
#trengo-web-widget{
  display: none !important;
}
`;

const ScrollSnap = styled((props) => <div onScroll={props.onScroll} style={props.style}>{(props.children || []).map((c, i) => <div key={i} onScroll={e => e.stopPropagation(/* this is to stop children scroll events from firing the parent's scroll event */)} className="snap-item">{c}</div>)}</div>)`
    flex-basis: 50%;
    max-height: 100vh;

    scroll-snap-stop: always;
    scroll-behavior: smooth;

    .snap-item{
      scroll-snap-align: start;
      /* ${props => !props.isMobile ? 'overflow-y: auto;' : ''} */
    }

    &::-webkit-scrollbar {
        display: none;
    } 
    
`;

const SideMenuDots = styled.div`
  position: fixed;
  z-index: 100;
  top: 50%;
  opacity: 1;
  transform: translateY(-50%);
  right: 17px;

  ol, ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  ul{
    margin: 0;
    padding: 0;
  }
  ul li {
    display: block;
    width: 14px;
    height: 13px;
    margin: 15px;
    position: relative;
    margin-right: 5px;
  }
  ul li a {
    display: block;
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    cursor: pointer;
    text-decoration: none;
  }
  .fp-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  ul li a span{
    border-radius: 50%;
    position: absolute;
    z-index: 1;
    height: 4px;
    width: 4px;
    border: 0;
    background: #333;
    left: 50%;
    top: 50%;
    margin: -2px 0 0 -2px;
    transition: all 0.1s ease-in-out;
    box-shadow: 0px 0px 3px 0.5px white;
  }
  ul li:hover a span {
    width: 10px;
    height: 10px;
    margin: -5px 0px 0px -5px;
  }
  ul li a.active span, ul li:hover a.active span{
    height: 12px;
    width: 12px;
    margin: -6px 0 0 -6px;
    border-radius: 100%;
  }
  ul li .fp-tooltip {
    position: absolute;
    top: -9px;
    color: #fff;
    font-size: 14px;
    white-space: nowrap;
    max-width: 220px;
    overflow: hidden;
    display: block;
    opacity: 0;
    width: 0;
    cursor: pointer;
    text-transform: capitalize;
  }
  ul li .fp-tooltip:after {
    color: #000;
    mix-blend-mode: difference;
  }
  ul li .fp-tooltip.fp-right {
    right: 20px;
  }

  ul li:hover .fp-tooltip, &.fp-show-active a.active + .fp-tooltip {
    transition: opacity 0.2s ease-in;
    width: auto;
    opacity: 1;
    background: rgba(255,255,255,0.7);
    padding: 5px;
    border-radius: 18px;
    padding-left: 10px;
    padding-right: 10px;
    color: black;
  }
`;

const scrollableSections = ['welcome', 'about-us,about-us-2', 'news', 'special-offers', 'api', 'register', 'contact-us'];

var isScrolling;

class Home extends PureComponent {
  state = {
    selectedSectionBullet: 'welcome',
    headSectionAnimationCompleted: false,
  }

  selectSectionByHash() {
    let hash = this.props.location.hash || '#welcome';

    if (!this.props.location.hash) {
      this.props.history.push(hash)
    }

    this.setState({ selectedSectionBullet: hash.replace('#', '') })

    setTimeout(() => {
      document.location.hash = '';
      document.location.hash = hash;
    }, 500)
  }

  componentDidMount() {
    const { selectHome } = this.props;
    selectHome();

    // added this because there is no point in keeping the initial hash, as it would break the second 
    // time you click on the Register button, it wasn't scrolling to section if hash is already set to /#register
    if (document.location.hash) {
      document.location.hash = '';
    }

    const { page, token } = this.props.match.params;
    if (page === 'reset' && token) {
      this.resetPassword(token);
    }

    if (page === 'verify' && token) {
      this.verifyUser(token);
    }
  }

  async resetPassword(token) {
    const { openPasswordDialog, openLoginDialog, closeDialog, openMessageDialog } = this.props;
    openPasswordDialog({
      description: 'Enter your new Password',
      onClose: () => {
        closeDialog()
        this.props.history.push('/');
      },
      onContinue: async values => {
        try {
          const res = await api.post('/reset', { id: token, password: values.password })
          openLoginDialog({
            description: 'Please enter your email and new password',
            status: { general: <span><img alt="" src="/images/ok.svg" style={{ verticalAlign: 'middle' }} /> Your password has been reset</span> }
          })
        } catch (err) {
          const errorMessage = toTitleCase(err.response.data.errors.msg.split('_').join(' '))
          openMessageDialog({
            headline: ('Error'),
            description: errorMessage,
            onComplete: () => {
              closeDialog();
            },
            hideBackButton: true,
          })
        }

      }
    })
  }

  async verifyUser(token) {
    const { openMessageDialog, closeDialog } = this.props;
    this.props.history.push('/');
    try {
      const res = await api.post('/verify', { id: token })
      const { email, verified } = res.data;
      if (verified) {
        openMessageDialog({
          headline: (<img alt="" src="/images/email_confirmed.svg" />),
          description: (<span>
            Thank you for verifying your email<br />
            Henig Diamonds web team will audit your provided information and will get in touch shortly to confirm your registration.<br />
            <br />
            In the interim - please don’t hesitate to contact our sales team
          </span>),
          onComplete: () => {
            closeDialog();
          },
          hideBackButton: true,
        })
      }
    } catch (err) {
      const errorMessage = toTitleCase(err.response.data.errors.msg.split('_').join(' '))
      openMessageDialog({
        headline: ('Error'),
        description: errorMessage,
        onComplete: () => {
          closeDialog();
        },
        hideBackButton: true,
      })
    }
  }

  onSectionsScroll(e) {
    var scrollTop = (e && e.target.scrollTop) || 0;

    clearTimeout(isScrolling);

    // Set a timeout to run after scrolling ends
    isScrolling = setTimeout(() => {

      if (this.props.onSectionsScroll) {
        this.props.onSectionsScroll(scrollTop);
      }

      // check if the anchor elements are visible
      scrollableSections.forEach((sectionId) => {
        const sectionIds = sectionId.split(',')
        const els = sectionIds.map(s => document.getElementById(s));

        els.forEach((el, i) => {
          if (el && el.offsetTop === scrollTop) {
            // update the URL hash

            var urlHash = "#" + sectionIds[i];

            // this was making the loading bar appear and slower performance overall
            // this.props.history.push(urlHash);
            //document.location.hash = urlHash; // works better.

            document.getElementById(sectionIds[i]).scrollIntoView({
              behavior: 'smooth', // smooth scroll
              block: 'start' // the upper border of the element will be aligned at the top of the visible part of the window of the scrollable area.
            })

            /* .scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: 'nearest',
            }); */

            this.setState({ selectedSectionBullet: sectionIds[0] })
          }
        });
      })

    }, 500);
  }

  headSectionAnimationComplete() {
    const { headSectionAnimationComplete } = this.props;
    headSectionAnimationComplete();

    setTimeout(() => this.setState({ headSectionAnimationCompleted: true }), 1000)
  }

  render() {
    const { selectedSectionBullet, headSectionAnimationCompleted } = this.state;
    const { openLoginDialog, openPasswordDialog, blogPosts = [], width, openEmailDialog, pushMessageToSnackbar } = this.props;

    return (
      <Fragment>
        <ScrollSnap isMobile={width === 'xs'} onScroll={e => this.onSectionsScroll(e)} style={width !== 'xs' && headSectionAnimationCompleted ? { scrollSnapType: 'y mandatory', overflowY: 'scroll' } : { overflowY: width !== 'xs' ? 'hidden' : 'scroll' }}>
          <HeadSection
            id={'welcome'}
            headSectionAnimationComplete={() => this.headSectionAnimationComplete()}
            headSectionLoaded={() => this.selectSectionByHash()}
            openEmailDialog={openEmailDialog}
          />
          <AboutSection
            id={'about-us'}
            bigImage="5ff638ea2a34245c31b64dea"
            smallTitle="5ff638ea2a34245c31b64deb"
            bigTitle="5ff638ea2a34245c31b64dec"
            description="5ff638ea2a34245c31b64ded"
            smallImage="5ff638ea2a34245c31b64dee"
          />
          <AboutSection2
            id={'about-us-2'}
            readMorePath={'/about-us'}
            bigImage="5ff647a82a34245c31b64def"
            bigImage2="5ff648bf2a34245c31b64df0"
            bigImage3="5ff648fb2a34245c31b64df1"
            smallTitle="5ff6495f2a34245c31b64df2"
            bigTitle="5ff64b4d2a34245c31b64df3"
            description="5ff64b862a34245c31b64df4"
          />
          <NewsSection id={'news'} blogPosts={blogPosts} />
          <SpecialOffersSection id={'special-offers'} />
          <APISection 
            id={'api'}
            readMorePath={'/api'}
            openEmailDialog={openEmailDialog}
            pushMessageToSnackbar={pushMessageToSnackbar}
            history={this.props.history}
            openRegisterDialog={this.props.openRegisterDialog}
          />
          <RegisterSection
            id={'register'}
            onSubmitComplete={(values, userExists) => {
              if (userExists) {
                openLoginDialog({ initialValues: values })
              } else {
                openPasswordDialog({ initialValues: values })
              }
            }}
          />
          <ContactUsSection id={'contact-us'} />
          <MapSection />
          <Footer openEmailDialog={openEmailDialog} />

          {!(headSectionAnimationCompleted || selectedSectionBullet !== 'welcome') && <HideTrengoChat />}
        </ScrollSnap>

        {headSectionAnimationCompleted && width !== 'xs' && <SideMenuDots>
          <ul>
            {scrollableSections.map(sectionIds => {
              const sectionId = sectionIds.split(',')[0]
              return (<li>
                <a className={selectedSectionBullet === sectionId ? 'active' : null} onClick={() => {
                  document.getElementById(sectionId).scrollIntoView({
                    behavior: 'smooth', // smooth scroll
                    block: 'start' // the upper border of the element will be aligned at the top of the visible part of the window of the scrollable area.
                  })
                }}>
                  <span className="fp-sr-only">{sectionId}</span>
                  <span />
                </a>
                <div className="fp-tooltip fp-right">{sectionId.split('-').join(' ')}</div>
              </li>)
            })}
          </ul>
        </SideMenuDots>}

      </Fragment>
    );
  }
}

Home.propTypes = {
  selectHome: PropTypes.func.isRequired
};

export default withWidth()(Home);